import { ComunicatorAllegatiDocxView } from "@/pages/ComunicatorPage";

export default function ComAllegatiPage() {
  return (
    <div>
      <div className="sw-page-title">
        <h1>📎 Allegati DOCX</h1>
        <div className="sw-breadcrumb">Home &gt; Allegati DOCX</div>
      </div>
      <ComunicatorAllegatiDocxView />
    </div>
  );
}
